import React from "react";
import classes from "./OnboardingCreateProfileSelect.module.css";
import { Field, ErrorMessage } from "formik";
import OnboardingCreateProfileLabel from "./OnboardingCreateProfileLabel";

const OnboardingCreateProfileSelect = ({ options, name, label }) => {
  const optionElements =
    options &&
    options.map((option) => (
      <option
        key={option.value}
        value={option.value}
        className={classes.selectOptions}
      >
        {option.key}
      </option>
    ));

  return (
    <>
      <OnboardingCreateProfileLabel label={label} name={name} />
      <div
        className={`position-relative ${classes.inputSelectTextAreaContainer}`}
      >
        <Field
          as="select"
          id={name}
          name={name}
          className={`${classes.inputSelectTextArea}`}
        >
          <option
            style={{ display: "none" }}
            key="none"
            value="none"
            defaultChecked
          >
            Select Value
          </option>
          {optionElements}
        </Field>
        <span class={`material-icons ${classes.dropDownArrow}`}>
          arrow_drop_down
        </span>
        <span className={classes.errorMessage}>
          <ErrorMessage name={name} />
        </span>
      </div>
    </>
  );
};

export default OnboardingCreateProfileSelect;
